import ufeApi from 'services/api/ufeApi';
import authUtils from 'utils/Authentication';
import RCPSCookies from 'utils/RCPSCookies';
import userUtils from 'utils/User';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Auto+Login+API

async function autoLogin(_body = {}) {
    const url = '/gway/v1/dotcom/auth/v2/refreshToken';
    const headers = {
        'Content-type': 'application/json',
        'x-requested-source': 'web'
    };

    if (RCPSCookies.isRCPSAuthEnabled()) {
        headers.deviceId = await authUtils.getFingerPrint();
    }

    const email = _body.email || userUtils.getProfileEmail();
    const payload = email ? { email } : {};

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            credentials: 'include',
            headers,
            body: JSON.stringify(payload)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default { autoLogin };
